import {$, $$, createElement, empty, getParentElementByClassName, getParentElementById, getParentElementByTagName, hide, html_chargement_en_cours, show} from "./Dom.ts";
import {createModale, generateModale, hideModal, initAjaxModale, showModal} from "./Modal.ts";
import {$get, $post, $postForm} from "./Ajax.ts";
import {initTooltips} from "./Tooltip.ts";
import {initLinkToOnglet} from "./Onglets.ts";
import {SelecteurDeServices} from "./SelecteurDeServices.ts";
import {setCloneFormState} from "../../dossier/js/FormUtils.ts";
import {refreshPage} from "./Utils.ts";
import {initSelects} from "./Select.ts";
import {animateLoadingButton} from "./Animate.ts";
import {handleRemoveAccess} from "./AccessLecture.ts";

export function initActions() {
    $('#menu-btn-actions')?.addEventListener('click', (event) => {
        event.stopPropagation()
        event.preventDefault()
        openActionModal()
    })
}

export function openActionModal() {
    initAjaxModale('actions-modal', {
            title: "Menu des actions :", title_in_header: true,
        }, window.Openscop.url_get_action_bloc).then(modale => {
            initActionsListeners(modale)
            initLinkToOnglet(modale)
            initTooltips(modale)
        })
}

export function closeActionsMenu() {
    const modal = $('#actions-modal')
    if(modal && modal.classList.contains('is-open')) {
        hideModal("actions-modal")
    }
}

function initActionsListeners(modale: HTMLElement) {
    if (!window.Openscop.type_view) return
    switch (window.Openscop.type_view) {
        case "dossier":
            initActionsOrganisateur(modale)
            break;
        case "consultation":
            initActionsAccess(modale)
            break;
        case "instruction":
            initActionsInstructeur(modale)
            break;
        case "avis":
            initActionsAvis(modale)
            break;
    }
}

function initActionsOrganisateur(modale: HTMLElement) {
    $(`#clone-dossier`, modale)?.addEventListener('click', showCloneModale)
    $(`#demande-evaluation-n2k`, modale)?.addEventListener('click', showModalDemandeN2k)
    $('#octroyer-acces-lecture-simple', modale)?.addEventListener('click', showAccessConsultationOrganisateurModale);
    $('#exporter-dossier', modale)?.addEventListener('click', showExportDossierModale)

    $$<HTMLAnchorElement>('[data-confirm]', modale).forEach(showConfirmModal)
}

function initActionsAccess(modale: HTMLElement) {
    $('#octroyer-acces-lecture-simple', modale)?.addEventListener('click', showAccessConsultationOrganisateurModale);
    $('#exporter-dossier', modale)?.addEventListener('click', showExportDossierModale)
    $("#abandonner-acces-lecture-simple", modale)?.addEventListener("click", handleRemoveAccess)
    $('#autoriser-depot-hors-delai', modale)?.addEventListener('click', showHorsDelaiModal)
}

function initActionsInstructeur(modale: HTMLElement) {
    $(`#demande-evaluation-n2k`, modale)?.addEventListener('click', showModalDemandeN2k)
    $$('.octroi-acces-lecture', modale).forEach(lien => lien.addEventListener('click', showAccessConsultationInstructeurModale));
    $('#exporter-dossier', modale)?.addEventListener('click', showExportDossierModale)
    $('#btn-modal-demande-avis', modale)?.addEventListener('click', showModalAvis)
    $('#verifier_affectation_link', modale)?.addEventListener('click', showAffectationModal)
    // fixme : semble etre un autre cas que celui des octroi-acces-lecture ?
    // $$('.btn-modal-access-lecture', modale).forEach(el => el?.addEventListener('click', showModalAccessEnLecture))
    $('#octroi-acces-mairies', modale)?.addEventListener('click', showModalAccessEnLectureToutesMairies)
    $('#demander_ajout_parcours', modale)?.addEventListener("click", demandeAjoutParcour)
    $('#instruction_liste_fichier_genere')?.addEventListener('click', showFichierGenere)


    $$<HTMLAnchorElement>('[data-confirm]', modale).forEach(showConfirmModal)
}

function initActionsAvis(modale: HTMLElement) {
    $('#verifier-assignation-avis')?.addEventListener('click', showAffectationModal)
    $('#exporter-dossier')?.addEventListener('click', showExportDossierModale)
    $$('.octroi-acces-lecture', modale).forEach(lien => lien.addEventListener('click', showAccessConsultationInstructeurModale));

    $('#mandater-avis-preavis')?.addEventListener('click', showManderAvisModale)
    $('#envoyer-demande-preavis-services-interne')?.addEventListener('click', showInterogerModale)
    $('#addresser-avis-preavis')?.addEventListener('click', showAddresserModale)


    $$<HTMLAnchorElement>('[data-confirm]', modale).forEach(showConfirmModal)
}

function showConfirmModal(element: HTMLAnchorElement) {
    function handleAjaxClick(event: DOMEvent<HTMLAnchorElement>) {
        event.preventDefault()
        const url = new URL(event.target.href)
        let params: string | null = element.getAttribute("data-params")
        if(params) {
            const paramEntries = JSON.parse(params) as {[key: string]: string}
            Object.entries(paramEntries).forEach(([key, value]: [string, string]) => {
                url.searchParams.append(key, value)
            })
        }
        if (url) {
            animateLoadingButton(getParentElementByClassName(event.target, "fr-btn"))
            $get(url.toString()).then(() => {
                refreshPage()
            })
        }
    }
    function handleClick(event: DOMEvent<HTMLAnchorElement>) {
            event.preventDefault()
            closeActionsMenu()
            let annuler: HTMLAnchorElement | HTMLButtonElement | undefined
            if(element.hasAttribute('data-cancel')) {
                annuler = createElement("a", ['fr-btn', 'fr-btn--secondary']) as HTMLAnchorElement
                annuler.href = element.getAttribute("data-cancel") as string
                annuler.addEventListener('click', () => {
                    animateLoadingButton(annuler!)
                })
                if (element.hasAttribute('data-ajax')) {
                    annuler.addEventListener('click', handleAjaxClick)
                }
                annuler.innerText = "Infirmer"
            } else {
                annuler = createElement("button", ['fr-btn', 'fr-btn--secondary'])
                annuler.innerText = "Annuler"
                annuler.setAttribute('data-micromodal-close', "")
            }
            const confirmer = createElement("a", ['fr-btn', 'test-btn-valider'])
            confirmer.innerText = "Confirmer"
            confirmer.href = element.href
            if (element.hasAttribute('data-ajax')) {
                confirmer.addEventListener('click', handleAjaxClick)
            } else {
                confirmer.addEventListener('click', () => {
                    animateLoadingButton(confirmer)
                })
            }
            generateModale('confirm-modale', {
                title: element.getAttribute('data-confirm') ?? "Confirmer l'action", actions: [annuler, confirmer]
            })
        }
    element.addEventListener('click', handleClick)
}

function showModalDemandeN2k(event: DOMEvent<HTMLAnchorElement>) {
    const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    if(target.hasAttribute('data-create')) return
    event.preventDefault()

    const url = target.href
    closeActionsMenu()
    initAjaxModale("n2k-modale", {
        title: "Effectuer une évaluation Natura 2000", title_in_header: true,
    }, url).then(modale => {
        setCloneFormState()
        $<HTMLFormElement>('form', modale)!.action = url
        handleFormEvent(modale, url)
    })
}

function showCloneModale(event: DOMEvent<HTMLElement>) {
    function cloneDossier(event: DOMEvent<HTMLFormElement>) {
        event.preventDefault()
        const form = event.target
        animateLoadingButton($('.fr-btn[type="submit"]', form))
        const formData = new FormData(form)
        $postForm(form.action, formData).then((response) => {
            if (response.response.status !== 200) {
                if (window.Openscop.debug) console.error('erreur')
            } else {
                window.location.assign(response.body)
            }
        }).catch((response) => {
            const action = form.action
            const target = form.parentElement
            target.innerHTML = response.message
            setCloneFormState()
            $<HTMLFormElement>('form', target)!.action = action
            $(`form`, target)?.addEventListener('submit', cloneDossier)
        })
    }


    event.preventDefault();
    const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    const url = target.href
    closeActionsMenu()
    initAjaxModale("clone-modale", {
        title: "Créer un nouveau dossier", title_in_header: true,
    }, url).then(modale => {
        setCloneFormState()
        $<HTMLFormElement>('form', modale)!.action = url
        $('form', modale)?.addEventListener('submit', cloneDossier)
    })
}

function showAccessConsultationOrganisateurModale(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    closeActionsMenu()
    const modale = createModale('consultation-simple', {
        title: window.Openscop.selecteur.consultation.modal_title,
    })
    if (modale) {
        show($<HTMLElement>('#consult_div', modale))
        show($<HTMLElement>('#modal-instance-selecteur', modale))
        hide($<HTMLElement>('#modal-categorie-selecteur', modale))
        let selecteur: SelecteurDeServices
        showModal('consultation-simple', {
            disableScroll: true, onClose: () => {
                if (selecteur?.demandeEnvoyer) location.reload()
            }
        })
        selecteur = new SelecteurDeServices({
            ...window.Openscop.selecteur.consultation, ajout: "simple",
        })
    }
}

function showAccessConsultationInstructeurModale(event: DOMEvent<HTMLAnchorElement>) {
    event.preventDefault()
    closeActionsMenu()
    const target = getParentElementByClassName(event.target, 'octroi-acces-lecture')
    if (target) {
        const type = target.getAttribute('data-type')
        const modale = createModale(`consultation-${type}`, {
            title: window.Openscop.selecteur.consultation.modal_title,
        })
        if (modale) {
            show($<HTMLElement>('#consult_div', modale))
            show($<HTMLElement>('#modal-instance-selecteur', modale))
            hide($<HTMLElement>('#modal-categorie-selecteur', modale))
            let selecteur: SelecteurDeServices
            showModal(`consultation-${type}`, {
                disableScroll: true, onClose: () => {
                    if (selecteur?.demandeEnvoyer) location.reload()
                }
            })
            let modaleExist = window.Openscop.selecteur.acces_consult_simple_existant
            if (type === "complet") modaleExist = window.Openscop.selecteur.acces_consult_complet_existant
            if (!modaleExist) {
                selecteur = new SelecteurDeServices({
                    ...window.Openscop.selecteur.consultation, ajout: type,
                })
                if (type === "complet") window.Openscop.selecteur.acces_consult_complet_existant = SelecteurDeServices
                else window.Openscop.selecteur.acces_consult_simple_existant = SelecteurDeServices
            } else {
                selecteur = modaleExist
            }
        }
    }
}

function showExportDossierModale(event: DOMEvent<HTMLAnchorElement>) {
    event.preventDefault()
    function handleExport(eventExport: DOMEvent<HTMLAnchorElement>) {
        eventExport.preventDefault()
        eventExport.stopPropagation()
        const linkElement = getParentElementByTagName(eventExport.target, 'a') as HTMLAnchorElement
        const parent = linkElement?.parentElement
        const url = linkElement?.href
        const stringReplacement = $('.export_lien_attente')
        if(parent && url && stringReplacement) {
            parent.innerHTML = stringReplacement.innerHTML
            $get(url)
        }
    }
    const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    const url = target.href
    const params: any = {
        avis_pk: undefined,
    }
    if (target.hasAttribute("data-avis")) params.avis_pk = target.getAttribute("data-avis")
    closeActionsMenu()
    initAjaxModale("export-modale", {
        title: "Exporter le dossier", title_in_header: true,
    }, url, params).then(modale => {
        $$('.export_lien', modale).forEach(lien => lien?.addEventListener('click', handleExport))
    })
}

function showModalAvis(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const modale = createModale('demande_avis', {
        title: window.Openscop.selecteur.demande_avis.modal_title,
    })
    closeActionsMenu()
    if (modale) {
        let selecteur: SelecteurDeServices
        showModal('demande_avis', {
            // disableScroll: true,
            onClose: () => {
                if (selecteur?.demandeEnvoyer) refreshPage()
            }
        })
        if (!window.Openscop.selecteur.selecteur_demande_avis) {
            selecteur = new SelecteurDeServices({
                ...window.Openscop.selecteur.demande_avis
            })
            window.Openscop.selecteur.selecteur_demande_avis = SelecteurDeServices
        } else {
            selecteur = window.Openscop.selecteur.selecteur_demande_avis
        }
    }
}

function showAffectationModal(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const modalBody = $("#modal-affectation-dossier-body")
    if (modalBody) {
        closeActionsMenu()
        empty(modalBody)
        modalBody?.appendChild(html_chargement_en_cours())
        const modale = createModale('modal-affectation-dossier')
        // myModal.show()
        if (modale) {
            showModal(modale.id, {})
            $get(window.Openscop.url_reaffecter_dossier).then((reponse) => {
                modalBody.innerHTML = reponse.body
                initSelects(modalBody)
                initTooltips(modalBody)
                $('#agent-assignation-form')?.addEventListener('submit', (event: DOMEvent<HTMLFormElement>) => {
                    event.preventDefault()
                    animateLoadingButton($('#assigner_submit'), 'Traitement en cours.')
                    let val = $<HTMLSelectElement>('#assigner_select')?.slim?.getSelected()
                    const url = `${event.target.action}?type_dossier=instruction&pk_user=${val}`
                    $post(url).then(() => {
                        refreshPage()
                    })
                })
            })
        }
    }
}

function showHorsDelaiModal(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    closeActionsMenu()
    initAjaxModale("action-hors-delai", {
        title: "Autoriser le dépôt hors délai", title_in_header: true,
    }, window.Openscop.url_autorise_hors_delai)
}

function showModalAccessEnLectureToutesMairies(event: DOMEvent<HTMLAnchorElement>) {
    event.preventDefault()
    const lien = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    function handleClick() {
        const dossier_complet = $<HTMLInputElement>("#motif_toutes_mairies_complet")
        const raison = $<HTMLInputElement>("#motif_octroi_acces_lecture_toutes_mairies")
        const url = lien?.href ?? ""
        if (dossier_complet && raison) {
            $post(url, {dossier_complet: dossier_complet.value, raison: raison.value}).finally(() => {
                refreshPage()
            })
        }
    }
    function createRaisonOctroiToutesMairies(complet = true) {
        let input_complet = createElement("input");
        input_complet.id = "motif_toutes_mairies_complet";
        input_complet.value = String(complet);
        input_complet.type = "hidden";
        const textarea = createElement('div', ['fr-input-group', 'fr-p-2w'])
        textarea.innerHTML = `
    <label class="fr-label" for="motif_octroi_acces_lecture_toutes_mairies">
        Raison :
    </label>
    <textarea
            class="fr-input"
            id="motif_octroi_acces_lecture_toutes_mairies"
            name="motif_octroi_acces_lecture_toutes_mairies"
            rows="6"
            cols="55"
    ></textarea>`

        const btn = createElement('button', ['fr-btn'])
        btn.id = "enregistrer_motif_octroi_acces_lecture_toutes_mairies"
        btn.innerText = "Enregistrer"

        btn.addEventListener('click', handleClick)

        return generateModale('raison_modal_toutes_mairies', {
            title: 'Veuillez en détailler la raison',
            content: textarea,
            actions: [btn, input_complet,],
        })
    }
    closeActionsMenu()
    createRaisonOctroiToutesMairies(true);
}

function demandeAjoutParcour(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const target = getParentElementById(event.target, "demander_ajout_parcours")
    let url_ajout_parcour = target?.dataset.url
    let dossier_pk = target?.dataset.pk

    if(url_ajout_parcour && dossier_pk) {
        closeActionsMenu()
        let title = "Veuillez détailler la raison de la demande d'ajout de parcours"
        const modalId = "motif_demande_ajout_carto"
        generateConfirmationModale(modalId, title)
        const handleSubmitConfirmation = () => {
        let data = {
            champ: "carto",
            pk: dossier_pk,
            motif_demande_modification_parcours: $<HTMLInputElement>('#motif_demande_modification')?.value
        };
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        $post(url_ajout_parcour, data, headers).then(() => {
            hideModal(modalId);
            refreshPage();
        })
    }
        $('#motif_demande_ajout_carto')?.addEventListener('submit', handleSubmitConfirmation)
        $('#enregistrer_demande_modif')?.addEventListener('click', handleSubmitConfirmation)
    }
}

function generateConfirmationModale(modalId: string, title: string) {
    const content = createElement('form')
    content.id = modalId
    content.dataset
    const infos_complementaires = createElement('div')
    infos_complementaires.innerHTML = 'Informations importantes concernant les demandes de modifications : ' +
        '<i class="remix-aide-contextuelle" role="button" tabindex="0" data-help="infos_complementaires_elements_modifiables" aria-hidden="true"></i>'
    const motif_demande_modification = createElement('textarea', ['fr-input'])
    motif_demande_modification.id = "motif_demande_modification"
    motif_demande_modification.rows = 6
    motif_demande_modification.cols = 55

    const actionSave = createElement('button', ['fr-btn'])
    actionSave.id = "enregistrer_demande_modif"
    actionSave.innerText = "Enregistrer"
    const actionCancel = createElement('button', ['fr-btn', 'fr-btn--secondary'])
    actionCancel.id = "annuler_enregistrer_demande_modif"
    actionCancel.innerText = "Annuler"
    actionCancel.setAttribute("data-micromodal-close", "")

    content.appendChild(infos_complementaires)
    content.appendChild(motif_demande_modification)

    const modale = generateModale('dossier-verouiller-modal', {
        title,
        content,
        actions: [actionSave, actionCancel]
    })
    initTooltips(content)
    return modale
}

function showManderAvisModale(event: DOMEvent<HTMLAnchorElement>) {
    event.preventDefault()
    closeActionsMenu()
    const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    initAjaxModale("mandater-avis-preavis", {
        title: target.innerText.trim(),
        title_in_header: true,
    }, target.href).then((modale) => {
        initSelects(modale)
        initTooltips(modale)
        handleFormEvent(modale)
    })
}

function showInterogerModale(event: DOMEvent<HTMLAnchorElement>) {
    event.preventDefault()
    closeActionsMenu()
    const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    initAjaxModale("envoyer-demande-preavis-servuces-interne", {
        title: target.innerText.trim(),
        title_in_header: true,
    }, target.href).then((modale) => {
        initSelects(modale)
        initTooltips(modale)
        handleFormEvent(modale)
    })
}

function showAddresserModale(event: DOMEvent<HTMLAnchorElement>) {
    event.preventDefault()
    closeActionsMenu()
    const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    initAjaxModale("addresser-avis-preavis", {
        title: target.innerText.trim(),
        title_in_header: true,
    }, target.href).then((modale) => {
        initSelects(modale)
        initTooltips(modale)
        handleFormEvent(modale)
    })
}

function handleFormEvent(container: HTMLElement, actionUrl?: string) {
    function handleSubmit(event: DOMEvent<HTMLFormElement>) {
        event.preventDefault()
        const form = event.target
        const formData = new FormData(form)
        $postForm(form.action, formData).then((response) => {
            if (response.response.status !== 200) {
                if (window.Openscop.debug) console.error('erreur')
            } else {
                refreshPage()
            }
        }).catch((response) => {
            const target = form.parentElement
            target.innerHTML = response.message
            const newForm = $<HTMLFormElement>(`form`, target)
            setCloneFormState()
            initTooltips(target)
            initSelects(target)
            if(actionUrl && newForm) {
                newForm.action = actionUrl
            }
            newForm?.addEventListener('submit', handleSubmit)
        })
    }
    $('form', container)?.addEventListener('submit', handleSubmit)
}

function showFichierGenere(event: DOMEvent<HTMLAnchorElement>) {
    event.preventDefault()
    closeActionsMenu()
    const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
    initAjaxModale("fichier_genere", {
        title: "Liste des fichiers générés",
        title_in_header: true,
    }, target.href).then((modale) => {
        initSelects(modale)
        initTooltips(modale)
        handleFormEvent(modale)
        $$('.fichier_generer_supprimer', modale).forEach(el => {
            el.addEventListener('click', (event: DOMEvent<HTMLAnchorElement>) => {
                event.preventDefault()
                const target = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
                const url = target.href
                $get(url).then((e) => {
                    if (e.response.status === 200) {
                        getParentElementByTagName(event.target, "li")?.remove()
                    }
                })
            })
        })
    })
}
